import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const handlePrev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const t = testimonials[current];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-accent-600 text-xs font-semibold tracking-widest uppercase mb-3 block">读者原声</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              （ 读者口碑 ）
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-12 relative border border-background-200/60">
            <div className="flex items-center gap-1 mb-6">
              {[...Array(t.rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
              <span className="ml-2 px-2.5 py-0.5 rounded-full bg-foreground-900 text-white text-xs font-semibold whitespace-nowrap">
                {t.rating}.0
              </span>
            </div>

            <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed font-serif mb-8">
              {t.content}
            </blockquote>

            <div className="flex items-center gap-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-foreground-900 font-semibold text-sm">{t.name}</p>
                <p className="text-foreground-400 text-xs">忠实读者</p>
              </div>
            </div>

            <div className="absolute bottom-8 right-8 flex items-center gap-2">
              <button
                onClick={handlePrev}
                className="w-9 h-9 rounded-lg border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-line text-foreground-600"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === current ? 'bg-accent-500 w-5' : 'bg-foreground-300'
                }`}
                aria-label={`第 ${index + 1} 条评价`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}